import { Paragraph } from '@pb/shared/ui/atoms/paragraph';
import { Money } from '@pb/shared/ui/atoms/money';
import { Heading } from '@pb/shared/ui/atoms/heading';
import { TPropertyOfferOverviewProperties } from './property-offer-overview.types';
import {
    StyledContainer,
    StyledPropertyDetailsContainer,
    StyledPropertyImage,
    StyledPropertyImageContainer,
} from './property-offer-overview.styled';

export function PropertyOfferOverview({
    photoUrl,
    offersInTheRegionOf,
}: TPropertyOfferOverviewProperties) {
    return (
        <StyledContainer>
            <StyledPropertyImageContainer>
                <StyledPropertyImage src={photoUrl} alt="" />
            </StyledPropertyImageContainer>
            <StyledPropertyDetailsContainer>
                <Paragraph marginTop="small" marginBottom="none">
                    Offers in the Region of:
                </Paragraph>
                <Heading size="xxsmall" level={3}>
                    <Money amount={offersInTheRegionOf} />
                </Heading>
            </StyledPropertyDetailsContainer>
        </StyledContainer>
    );
}
